<template>
<v-card
  class="pa-4 rounded-lg fill-height"
  elevation="0"
  style="border: 1px solid #e0e0e0; transition: all 0.2s;"

>
  <div class="d-flex justify-space-between align-center flex-nowrap">
    <div>
      <div class="mb-2 d-flex gap-2">
        <h3 class="font-sm font-weight-bold grey--text text--darken-3">
          {{ data.name }}
        </h3>
        <div
          v-if="type === 'competenciesModal'"
        >
          <v-chip
            label
            small
            class="font-weight-medium px-3"
            style="background-color: #f3f4f6; color: #483CB9; height: 24px; font-size: 11px;"
          >
            {{ data.category }}
          </v-chip>
        </div>
      </div>
      <p class=" grey--text font-xs text--darken-1 mb-4" style="line-height: 1.4;">
        {{ data.description }}
      </p>
    </div>
    <div
      v-if="action"
      class="d-flex gap-2">
      <v-btn
        class="pa-4"
        color="#009E60"
        icon
        height="16"
        width="16"
        @click="$emit('edit')"
      >
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        class="pa-4"
        color="red"
        icon
        height="16"
        width="16"
        small
        @click="$emit('delete')"
      >
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </div>
  </div>
  <div
    v-if="type === 'competence'"
    class="d-flex gap-2 flex-wrap"
  >
    <v-chip
      label
      small
      class="font-weight-medium px-3"
      style="background-color: #f3f4f6; color: #483CB9; height: 24px; font-size: 11px;"
    >
      {{ data.category}}
    </v-chip>
  </div>
  <div
    v-if="type === 'preset'"
    class="d-flex gap-2 flex-wrap"
  >
    <v-chip
      v-for="competency of filteredCompetencies"
      :key="competency.id"
      label
      small
      class="font-weight-medium px-3"
      style="background-color: #f3f4f6; color: #483CB9; height: 24px; font-size: 11px;"
    >
      {{ competency.name }}
    </v-chip>
  </div>
</v-card>
</template>
<script>

export default {
  name: 'CardItem',
  props: {
    type: {
      type: String, // 'competence','preset'
      required: true,
    },
    data: {
      type: Object,
      required: true
    },
    action: {
      type: Boolean,
      required: true
    },
    competencies: {
      type: Array,
      default: () => []
    }
  },
  emits: ['edit', 'delete'],
  computed: {
    filteredCompetencies() {
      const competencyIds = new Set(
        (this.data.competences || []).map(c => (typeof c === 'object' ? c.id : c))
      );
      return this.competencies.filter(item =>
        competencyIds.has(item.id)
      );
    }
  }
};
</script>

<style scoped lang="scss">

</style>
